export enum BulkUploadStage {
    INITIAL = "initial",
    STAGING = "staging",
    PARSING = "parsing",
    PARSING_ERROR = "parsingError",
}

export const BULK_UPLOAD_CONFIG = {
    csvExtensions: [".csv"],

    csvMimeTypes: ["text/csv", "application/csv"],

    // Pickers match extensions on Windows and MIME types on macOS, so both are listed
    get csvAccept(): string {
        return [
            ...BULK_UPLOAD_CONFIG.csvExtensions,
            ...BULK_UPLOAD_CONFIG.csvMimeTypes,
        ].join(",")
    },

    /**
     * Whether a picked or dropped file can be treated as a CSV. The extension is the
     * primary signal because file.type depends on the OS registry and is often wrong
     * or empty.
     */
    isAcceptedCsvFile(file: File): boolean {
        const name = file.name.toLowerCase()

        return (
            BULK_UPLOAD_CONFIG.csvExtensions.some(extension =>
                name.endsWith(extension),
            ) ||
            BULK_UPLOAD_CONFIG.csvMimeTypes.includes(file.type.toLowerCase())
        )
    },
}
